import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type LinkedPartyStoreState = {
  partyIdByMessageId: Record<string, string>;
  actions: {
    linkPartyForEmail: (messageId: string, partyId: string) => void;
  };
};

const LOCAL_STORAGE_KEY = 'wg-linked-parties';

const INITIAL_VALUES: Omit<LinkedPartyStoreState, 'actions'> = Object.freeze({
  partyIdByMessageId: {},
});

const useLinkedPartyStore = create<LinkedPartyStoreState>()(
  persist(
    (set) => ({
      ...INITIAL_VALUES,

      actions: {
        linkPartyForEmail: (messageId: string, partyId: string) => {
          set((state) => ({
            ...state,
            partyIdByMessageId: {
              ...state.partyIdByMessageId,
              [messageId]: partyId,
            },
          }));
        },
      },
    }),
    {
      name: LOCAL_STORAGE_KEY,
      version: 0,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      partialize: ({ actions, ...rest }) => rest,
    },
  ),
);

export default useLinkedPartyStore;
